import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      activeStudents: "Active Undergraduate and Postgraduate Students",
      phds: "PhD Students",
      researchlabs: "Research Labs",
      latestNews: "Latest News",
      events: "Events",
      announcements: "Announcements",
      educationTitle: "Education in the Master's Program",
      studiesGuide: "Study Guides",
      studiesGuideDescription:
        "More information regarding the curriculum is provided in the Postgraduate Studies Program's Study Guide.",
      info: "Information",
      more: "More",
      erasmusTitle: "ERASMUS+ Programme",
      erasmusSubtitle: "Please enter text",
      education: "Education",
      doctoralTitle: "Doctoral Studies",
      courses: "Courses",
      schedule: "Schedule",
      thesis: "Thesis",
      quality: "Quality",
      postgraduateTitle: "Postgraduate Studies",
      resultsTitle: "Research Results",
      iccsTitle: "Institute of Communication and Computer Systems",
      historyTitle: "School's History",
      accessTitle: "Access",
      organizationTitle: "Organization",
      core: "Core",
      core_courses: "Core courses",
      y: "Flow Y: Computer Systems",
      l: "Flow L: Computer Software",
      h: "Flow H: Electronics, Circuits, Materials",
      d: "Flow D: Telecommunication Systems and Computer Networks",
      t: "Flow T: Electromagnetic Waves and Telecommunication",
      s: "Flow S: Signals, Automatic Control and Robotics",
      z: "Flow Z: Energy Conversion, High Voltages and Industry Applications",
      e: "Flow E: Electric Power Systems",
      o: "Flow O: Management and Decision Support Systems",
      i: "Flow I: Bioengineering",
      f: "Flow F: Physics",
      m: "Flow M: Mathematics ",
      miscellaneous: "Miscellaneous",
      humanities: "Humanities",
      semester: "Semester",
      title: "Title",
      labHours: "Lab Hours",
      lectureHours: "Lecture Hours",
      postalAddressDetails:
        "National Technical University of Athens\nSchool of Electrical and Computer Engineering\n9, Iroon Polytechniou St\nAthens, Postal Code 157 72",
      postalAddress: "Postal Address",
      labsOfSchool: "Academic Laboratories",
      room_one: "Room",
      room_other: "Rooms",
      floor_ordinal_one: "{{count}}st Floor", // 1st, 21st, 31st
      floor_ordinal_two: "{{count}}nd Floor", // 2nd, 22nd, 32nd
      floor_ordinal_few: "{{count}}rd Floor", // 3rd, 23rd, 33rd
      floor_ordinal_other: "{{count}}th Floor", // 4th, 5th, 24th, 11th
      login: "Login",
      register: "Register",
      alumniSystem: "in the alumni system",
      contributors: "Contributors",
      contact: "Contact",
      opinion: "Tell us your opinion",
      ece: "School of Electrical and Computer Engineering",
      ece_genitive: "of School of Electrical and Computer Engineering",
      ece_short: "ECE School",
      semfe: "School of Applied Mathematical and Physical Studies",
      semfe_short: "AMPS School",
      civil: "School of Civil Engineering",
      survey: "School of Rural, Surveying and Geoinformatics Engineering",
      survey_short: "RSE School",
      otherdep: "Professors from Other Institutions",
      ntua: "National Technical University of Athens",
      ntua_genitive: "of National Technical University of Athens",
      pelgroup: "PEL Group",
      search: "Search",
      new: "New",
      for: "for",
      allAnnouncements: "all announcements",
      allTheses: "all theses",
      allStaff: "all staff",
      chooseCourseCategory: "Select category",
      academicCalendar: "Academic Calendar",
      contactTitle: "Contact Info",
      newsTitle: "News of the School ECE",
      eventsTitle: "Events of the School ECE",
      utilitiesTitle: "Digital Services",
      services: "Services",
      links: "Links",
      undergraduate: "Undergraduate Courses",
      postgraduate: "Postgraduate Courses",
      doctoral: "Doctoral",
      staff: "Staff",
      master: "Postgraduate",
      phd1: "Doctoral",
      dep: "Faculty - Administrative",
      educational: "Educational",
      activities: "Events - Activities",
      timetables: "Timetables",
      scholarships: "Scholarships - Awards",
      rest: "Other",
      announcementsTitle: "Announcements",
      announcementDetails: "Announcement Details",
      announcementsUnavailable:
        "Announcements are currently available only in Greek.",
      research: "Research",
      people: "People",
      coursesTheses: "Courses & Theses",
      results: "Results",
      labs: "Laboratories",
      iccs1: "ICCS",
      libraries: "Libraries",
      staffHead: "People",
      academic: "Academic",
      laboratoryHead: "Laboratory",
      researchHead: "Research",
      administrative: "Administrative",
      school: "School",
      history: "History",
      access: "Access",
      organization: "Organization",
      news: "News",
      services_utilities: "Services",
      files: "Documents",
      professors: "Professors",
      professor_one: "Professor",
      professor_other: "Professors",
      personalWebsite: "Personal Website",
      shortCv: "Short CV",
      researchInterests: "Research Interests",
      "ongoing-research": "Ongoing Research",
      publications: "Publications",
      publicationsLink: "Publications Link",
      semester_ordinal_one: "{{count}}st Semester", // 1st, 21st, 31st
      semester_ordinal_two: "{{count}}nd Semester", // 2nd, 22nd, 32nd
      semester_ordinal_few: "{{count}}rd Semester", // 3rd, 23rd, 33rd
      semester_ordinal_other: "{{count}}th Semester", // 4th, 5th, 24th, 11th
      allFemalePlural: "All",
      obligatory: "Obligatory",
      bySelection: "Optional",
      foreignLanguage: "Foreign Language",
      interdep: "Interdepartmental",
      otherSchool: "Other school",
      optional: "Optional",
      lecturers: "Lecturers",
      coursePage: "Course Page",
      description: "Description",
      courseCode: "Code",
      available: "Available",
      inProgress: "In Progress",
      completed: "Completed",
      chooseFlow: "Choose Flow",
      regulation: "Regulation",
      contour: "Contour",
      thesisWork: "Diplomatic Thesis",
      registration: "Registrations",
      coursesAndEducationalProcedures:
        "Lessons and other Educational Processes",
      examPeriod: "Examination Period",
      gradesSubmission: "Grades Submission",
      period: "Period",
      start: "From",
      end: "Until",
      beta: "This website is currently in beta. The content is experimental, and functional changes may occur.",
      fall: "Fall",
      spring: "Spring",
      associateProfessors: "Associates",
      assistantProfessors: "Assistants",
      all: "All",
      associateProfessor: "Associate Professor",
      assistantProfessor: "Assistant Professor",
      faculty: "Faculty",
      emeriti: "Emeriti",
      retired: "Retired",
      edip: "Teaching",
      etep: "Technical",
      iccs: "ICCS Researchers",
      resassoc: "Research Associates",
      phd: "PhD Candidates",
      permanent: "Permanent",
      associates: "Associates",
      lecturersSel: "Lecturers",
      lecturer: "Lecturer",
      thesisTitle: "Diploma Thesis",
      academicTitle: "Academic Staff",
      staffDetails: "Staff Details",
      LaboratoryTitle: "Permanent Laboratory Staff",
      ResearchTitle: "Researchers",
      AdministrativeTitle: "Administrative Staff",
      noStaffFound:
        "No staff found matching your criteria. Try adjusting your search!",
      errorLoadingCourses: "Error loading courses.",
      fallSemester: "Fall Semester",
      springSemester: "Spring Semester",
      eceCoordination: "With the coordination of the E.C.E. School",
      eceParticaption: "With the participation of the E.C.E. School",
      masterDocCourses: "Doctoral Courses",
      responsibilities: "Responsibilities",
      schoolTitle:
        "Power Electronics Group - National Technical University of Athens",
      schoolTitleMin: "PEL Group - NTUA",
      homeDescription:
        "Official website of the Power Electronics Group at the National Technical University of Athens.",
      educationDescription:
        "Explore courses, educational activities and thesis opportunities supported by the PEL Group.",
      organizationDescription:
        "Learn how the PEL Group is organized, including responsibilities and structure.",
      announcementsDescription:
        "Read announcements, academic updates, events, and deadlines from the PEL Group.",
      announcementDetailsDescription:
        "Detailed information about PEL Group announcements, including content and attached files.",
      staffDescription:
        "Meet the academic staff, researchers and collaborators of the PEL Group.",
      staffDetailsDescription:
        "Profile and contact details for {{name}} at the PEL Group.",
      utilitiesDescription:
        "Access digital services and useful links for NTUA and the PEL Group.",
      filesDescription:
        "Download official documents and files for the PEL Group.",
      contactDescription:
        "Contact information and communication channels for the PEL Group.",
      accessDescription:
        "Directions, map, and access information for the PEL Group location.",
      librariesTitle: "Libraries",
      linkDes: "ECE - NTUA",
      historySubtitle100:
        "100 years of education and research on the cutting edge of technology",
      catalogueIssue:
        "Issuance by the Secretariat of the lists of postgraduate students in each course",
      fallCalendar: "Fall Semester",
      springCalendar: "Spring Semester",
      programTitle: "Power Electronics Group",
      moto: "Advancing the future of power electronics and energy conversion",
      map: "Map",
      welcomeTo: "Welcome to Postgraduate Studies Program",
      ofFemale: "of",
      eceSchool: "School of Electrical and Computer Engineering",
      useful_links: "Useful Links",
      and: "and",
      attachedFiles: "Attached Files",
      pelKicker: "National Technical University of Athens",
      pelHeroTitle: "Advancing the Future of Power Electronics",
      pelHeroSubtitle:
        "Research and education in modern power electronic systems, electrical drives, and energy conversion technologies.",
      pelHeroCta: "Explore our research",
      pelGroupTitle: "Power Electronics Group",
      pelLead:
        "The Power Electronics Group at the National Technical University of Athens combines theoretical analysis, advanced simulation, and experimental validation to develop efficient, reliable, and intelligent solutions for next-generation energy systems.",
      pelResearchCopy:
        "Current research spans grid-connected converters, modular multilevel converters (MMCs), HVDC systems, electric drives, high-frequency power conversion, battery energy storage systems, wide-bandgap semiconductor technologies, and AI-assisted energy management.",
      researchIntro:
        "Explore the research areas, projects and publications of the PEL Group.",
      peopleIntro:
        "Meet the faculty members, researchers, students and collaborators behind the PEL Group.",
      peopleProfessor: "Group Leader",
      peopleProfessorRole: "Associate Professor",
      peopleResearchers: "Researchers",
      peopleResearcherRole: "Researcher",
      peoplePhd: "PhD Students",
      peoplePhdRole: "PhD Candidate",
      peopleMsc: "M.Sc. & Diploma Thesis Students",
      peopleMscRole: "M.Sc. / Diploma Student",
      peopleCurrentActivities: "Current activities",
      peopleError: "People could not be loaded.",
      peopleEmpty: "Coming soon.",
      coursesThesesIntro:
        "Discover courses taught by the group and available diploma, master's and doctoral thesis topics.",
      coursesError: "Courses could not be loaded.",
      thesesError: "Theses could not be loaded.",
      currentTheses: "Current Diploma Theses",
      completedTheses: "Completed Diploma Theses",
      coursesThesesEmpty: "Coming soon.",
      contactIntro:
        "Get in touch with the PEL Group at the National Technical University of Athens.",
      researchCardText:
        "Converters, drives, energy storage and intelligent energy systems.",
      peopleCardText:
        "Meet our faculty, researchers, students and collaborators.",
      coursesThesesCardText:
        "Laboratory education and open thesis opportunities.",
      learnMore: "Learn more",
      footerCopyright:
        "School of Electrical and Computer Engineering, National Technical University of Athens",
      labImageAlt: "NTUA laboratory and research activity",
      peopleImageAlt: "Students and researchers in an academic setting",
      campusImageAlt: "National Technical University of Athens campus",
    },
  },
  el: {
    translation: {
      activeStudents: "Ενεργοί Προπτυχιακοί και Μεταπτυχιακοί Φοιτητές",
      phds: "Υποψήφιοι Διδάκτορες",
      researchlabs: "Ερευνητικά Εργαστήρια",
      latestNews: "Τελευταία Νέα",
      events: "Γεγονότα",
      announcements: "Ανακοινώσεις",
      educationTitle: "Εκπαίδευση στο ΠΜΣ",
      studiesGuide: "Οδηγοί Σπουδών",
      studiesGuideDescription:
        "Περισσότερες πληροφορίες σε σχέση με το πρόγραμμα σπουδών παρέχονται στον Οδηγό Σπουδών του Μεταπτυχιακού.",
      info: "Πληροφορίες",
      more: "Περισσότερα",
      erasmusTitle: "Πρόγραμμα ERASMUS+",
      erasmusSubtitle: "Εισάγετε Κείμενο",
      education: "Εκπαίδευση",
      doctoralTitle: "Διδακτορικές Σπουδές",
      courses: "Μαθήματα",
      schedule: "Προγραμματισμός",
      thesis: "Διπλωματικές",
      quality: "Πολιτική Διασφάλισης Ποιότητας",
      postgraduateTitle: "Μεταπτυχιακές Σπουδές",
      resultsTitle: "Ερευνητικά Αποτελέσματα",
      iccsTitle:
        "Ερευνητικό Πανεπιστημιακό Ινστιτούτο Συστημάτων Επικοινωνιών και Υπολογιστών",
      historyTitle: "Η ιστορία της Σχολής",
      accessTitle: "Πρόσβαση",
      organizationTitle: "Οργάνωση",
      core: "Κορμός",
      core_nominative_singular: "Κορμός",
      core_genitive_singular: "Κορμού",
      core_courses: "Μαθήματα κορμού",
      y: "Ροή Υ: Υπολογιστικά Συστήματα",
      l: "Ροή Λ: Λογισμικό Η/Υ",
      h: "Ροή Η: Ηλεκτρονική-Κυκλώματα-Υλικά",
      d: "Ροή Δ: Επικοινωνίες και Δίκτυα Υπολογιστών",
      t: "Ροή Τ: Κύματα και Τηλεπικοινωνίες",
      s: "Ροή Σ: Σήματα Έλεγχος και Ρομποτική",
      z: "Ροή Ζ: Ηλεκτρομηχανική Μετατροπή Ενέργειας, Υψηλές Τάσεις και Εγκαταστάσεις",
      e: "Ροή Ε: Συστήματα Ηλεκτρικής Ενέργειας",
      o: "Ροή Ο: Διοίκηση και Απόφαση",
      i: "Ροή Ι: Βιοϊατρική",
      f: "Ροή Φ: Φυσική",
      m: "Ροή Μ: Μαθηματικά",
      miscellaneous: "Μη εντασσόμενα στις Ροές",
      humanities: "Ανθρωπιστικά",
      semester: "Εξάμηνο",
      title: "Τίτλος",
      labHours: "Ώρες εργαστηρίου",
      lectureHours: "Ώρες Διδασκαλίας",
      postalAddressDetails:
        "Εθνικό Μετσόβιο Πολυτεχνείο\nΣχολή Ηλεκτρολόγων Μηχανικών και Μηχανικών Υπολογιστών\nΗρώων Πολυτεχνείου 9\nΑθήνα, T.K. 15780",
      postalAddress: "Ταχυδρομική Διεύθυνση",
      labsOfSchool: "Τα εργαστήρια της Σχολής",
      floor_ordinal_other: "{{count}}ος Όροφος",
      room_one: "Γραφείο",
      room_other: "Γραφεία",
      login: "Σύνδεση",
      register: "Εγγραφή",
      alumniSystem: "στο σύστημα αποφοίτων",
      contributors: "Συντελεστές",
      contact: "Επικοινωνία",
      opinion: "Πες μας τη γνώμη σου",
      ece: "Σχολή Ηλεκτρολόγων Μηχανικών και Μηχανικών Υπολογιστών",
      ece_genitive: "Σχολής Ηλεκτρολόγων Μηχανικών και Μηχανικών Υπολογιστών",
      ece_short: "Σχολή ΗΜΜΥ",
      ece_short_genitive: "Σχολής ΗΜΜΥ",
      semfe: "Σχολή Εφαρμοσμένων Μαθηματικών και Φυσικών Επιστημών",
      semfe_short: "Σχολή ΕΜΦΕ",
      civil: "Σχολή Πολιτικών Μηχανικών",
      survey:
        "Σχολή Αγρονόμων και Τοπογράφων Μηχανικών - Μηχανικών Γεωπληροφορικής",
      survey_short: "Σχολή ΑΤΜ",
      otherdep: "Διδάσκοντες από άλλα ιδρύματα",
      ntua: "Εθνικό Μετσόβιο Πολυτεχνείο",
      ntua_genitive: "Εθνικού Μετσοβίου Πολυτεχνείου",
      pelgroup: "Ε.ΔΕ.Μ.Μ.",
      search: "Αναζήτηση",
      new: "Νέο",
      for: "για",
      allAnnouncements: "σε όλες τις ανακοινώσεις",
      allTheses: "σε όλες τις διπλωματικές",
      allStaff: "σε όλο το προσωπικό",
      chooseCourseCategory: "Επιλέξτε κατηγορία",
      academicCalendar: "Ακαδημαϊκό Ημερολόγιο",
      contactTitle: "Στοιχεία Επικοινωνίας",
      newsTitle: "Τα νέα της Σχολής ΗΜΜΥ",
      eventsTitle: "Τα γεγονότα της Σχολής ΗΜΜΥ",
      utilitiesTitle: "Ηλεκτρονικές Υπηρεσίες",
      services: "Υπηρεσίες",
      links: "Σύνδεσμοι",
      undergraduate: "Προπτυχιακά μαθήματα",
      postgraduate: "Μεταπτυχιακά μαθήματα",
      postgraduate_nominative_singular: "Μεταπτυχιακό",
      postgraduate_genitive_singular: "Μεταπτυχιακού",
      postgraduate_nominative_plural: "Μεταπτυχιακά",
      postgraduate_genitive_plural: "Μεταπτυχιακών",
      doctoral: "Διδακτορικό",
      doctoral_nominative_singular: "Διδακτορικό",
      doctoral_genitive_singular: "Διδακτορικού",
      doctoral_nominative_plural: "Διδακτορικά",
      doctoral_genitive_plural: "Διδακτορικών",
      staff: "Προσωπικού",
      master: "Μεταπτυχιακών",
      phd1: "Διδακτορικών",
      dep: "ΔΕΠ - Διοίκησης",
      educational: "Εκπαίδευσης",
      activities: "Εκδηλώσεις - Δραστηριότητες",
      timetables: "Προγράμματα",
      scholarships: "Υποτροφίες - Βραβεία",
      rest: "Λοιπά",
      announcementsTitle: "Ανακοινώσεις",
      announcementDetails: "Λεπτομέρειες Ανακοίνωσης",
      announcementsUnavailable:
        "Οι ανακοινώσεις είναι διαθέσιμες μόνο στα Ελληνικά.",
      research: "Έρευνα",
      people: "Άνθρωποι",
      coursesTheses: "Μαθήματα & Διατριβές",
      results: "Αποτελέσματα",
      labs: "Εργαστήρια",
      iccs1: "ΕΠΙΣΕΥ",
      libraries: "Βιβλιοθήκες",
      staffHead: "Προσωπικό",
      academic: "Ακαδημαϊκό",
      laboratoryHead: "Εργαστηριακό",
      researchHead: "Ερευνητικό",
      administrative: "Διοικητικό",
      school: "Σχολή",
      history: "Ιστορία",
      access: "Πρόσβαση",
      organization: "Οργάνωση",
      news: "Νέα",
      services_utilities: "Υπηρεσίες",
      files: "Έντυπα",
      professor_male_one: "Καθηγητής",
      professor_male_other: "Καθηγητές",
      professor_female_one: "Καθηγήτρια",
      professor_female_other: "Καθηγήτριες",
      personalWebsite: "Προσωπική Ιστοσελίδα",
      shortCv: "Σύντομο Βιογραφικό",
      researchInterests: "Ερευνητικά Ενδιαφέροντα",
      "ongoing-research": "Τρέχουσα Έρευνα",
      publications: "Δημοσιεύσεις",
      publicationsLink: "Σύνδεσμος Δημοσιεύσεων",
      semester_ordinal_other: "{{count}}ο Εξάμηνο",
      allFemalePlural: "Όλες",
      obligatory: "Υποχρεωτικό",
      bySelection: "Επιλογής",
      foreignLanguage: "Ξενόγλωσσο",
      interdep: "Διατμηματικό",
      otherSchool: "Άλλης σχολής",
      optional: "Προαιρετικό",
      lecturers: "Διδάσκοντες",
      coursePage: "Σελίδα Μαθήματος",
      description: "Περιγραφή",
      courseCode: "Κωδικός",
      available: "Διαθέσιμο",
      inProgress: "Σε Εξέλιξη",
      completed: "Ολοκληρωμένο",
      chooseFlow: "Επιλέξτε Ροή",
      regulation: "Κανονισμός",
      contour: "Περίγραμμα",
      thesisWork: "Διπλωματική Εργασία",
      registration: "Εγγραφές",
      coursesAndEducationalProcedures:
        "Μαθήματα και λοιπές Εκπαιδευτικές Διαδικασίες",
      examPeriod: "Περίοδος Εξετάσεων",
      gradesSubmission: "Κατάθεση Βαθμολογίας",
      period: "Περίοδος",
      start: "Από",
      end: "Έως",
      beta: "Αυτή η ιστοσελίδα είναι σε δοκιμαστική έκδοση. Το περιεχόμενο είναι δοκιμαστικό. Ενδέχεται να υπάρξουν λειτουργικές αλλαγές.",
      fall: "Χειμερινό",
      spring: "Εαρινό",
      professors: "Καθηγητές",
      associateProfessors: "Αναπληρωτές",
      assistantProfessors: "Επίκουροι",
      all: "Όλοι",
      associateProfessor_male_one: "Αναπληρωτής Καθηγητής",
      associateProfessor_male_other: "Αναπληρωτές Καθηγητές",
      associateProfessor_female_one: "Αναπληρώτρια Καθηγήτρια",
      associateProfessor_female_other: "Αναπληρώτριες Καθηγήτριες",
      assistantProfessor_male_one: "Επίκουρος Καθηγητής",
      assistantProfessor_male_other: "Επίκουροι Καθηγητές",
      assistantProfessor_female_one: "Επίκουρη Καθηγήτρια",
      assistantProfessor_female_other: "Επίκουρες Καθηγήτριες",
      faculty: "Μέλη ΔΕΠ",
      emeriti: "Ομότιμοι",
      retired: "Συνταξιοδοτηθέντες",
      edip: "Διδακτικό (ΕΔΙΠ)",
      etep: "Τεχνικό (ΕΤΕΠ)",
      iccs: "Ερευνητές ΕΠΙΣΕΥ",
      resassoc: "Ερευνητικοί Συνεργάτες",
      phd: "Υποψήφιοι Διδάκτορες",
      permanent: "Μόνιμο",
      associates: "Εξωτερικοί Συνεργάτες",
      lecturersSel: "Λέκτορες",
      lecturer: "Λέκτορας",
      thesisTitle: "Διπλωματικές Εργασίες",
      academicTitle: "Διδακτικό Ερευνητικό Προσωπικό",
      staffDetails: "Λεπτομέρειες Προσωπικού",
      LaboratoryTitle: "Μόνιμο Εργαστηριακό Προσωπικό",
      ResearchTitle: "Ερευνητικό Δυναμικό",
      AdministrativeTitle: "Διοικητικό Προσωπικό",
      noStaffFound:
        "Δε βρέθηκε προσωπικό με αυτά τα κριτήρια. Δοκιμάστε να τροποποιήσετε την αναζήτηση!",
      errorLoadingCourses: "Σφάλμα κατά τη φόρτωση των μαθημάτων.",
      fallSemester: "Χειμερινό Εξάμηνο",
      springSemester: "Εαρινό Εξάμηνο",
      eceCoordination: "Συντονιζόμενα από τη Σχολή Η.Μ.Μ.Υ.",
      eceParticaption: "Με τη συμμετοχή της Σχολής Η.Μ.Μ.Υ.",
      masterDocCourses: "Διδακτορικά Μαθήματα",
      responsibilities: "Αρμοδιότητες",
      schoolTitleMin: "Ομάδα Ηλεκτρονικών Ισχύος - ΕΜΠ",
      schoolTitle: "Ομάδα Ηλεκτρονικών Ισχύος - Εθνικό Μετσόβιο Πολυτεχνείο",
      homeDescription:
        "Επίσημος ιστότοπος της Ομάδας Ηλεκτρονικών Ισχύος του Εθνικού Μετσόβιου Πολυτεχνείου.",
      educationDescription:
        "Δείτε το πρόγραμμα σπουδών, τα μαθήματα, τον προγραμματισμό και την πολιτική ποιότητας του ΠΜΣ.",
      organizationDescription:
        "Πληροφορίες για την οργάνωση, τη διοίκηση και τη δομή του ΠΜΣ.",
      announcementsDescription:
        "Ανακοινώσεις, ενημερώσεις, εκδηλώσεις και προθεσμίες του ΠΜΣ.",
      announcementDetailsDescription:
        "Λεπτομέρειες για ανακοινώσεις του ΠΜΣ, με περιεχόμενο και συνημμένα.",
      staffDescription:
        "Γνωρίστε το ακαδημαϊκό και διοικητικό προσωπικό του ΠΜΣ.",
      staffDetailsDescription:
        "Προφίλ και στοιχεία επικοινωνίας του/της {{name}} στο ΠΜΣ.",
      utilitiesDescription:
        "Ψηφιακές υπηρεσίες και χρήσιμοι σύνδεσμοι του ΕΜΠ και του ΠΜΣ.",
      filesDescription: "Κατεβάστε επίσημα έγγραφα και αρχεία του ΠΜΣ.",
      contactDescription:
        "Στοιχεία επικοινωνίας και τρόποι επικοινωνίας με το ΠΜΣ.",
      accessDescription:
        "Οδηγίες πρόσβασης και χάρτης για την τοποθεσία του ΠΜΣ.",
      librariesTitle: "Βιβλιοθήκες",
      linkDes: "ΗΜΜΥ - ΕΜΠ",
      historySubtitle100:
        "100 χρόνια εκπαίδευση και έρευνα στην αιχμή της τεχνολογίας",
      catalogueIssue:
        "Έκδοση από τη Γραμματεία των καταλόγων μεταπτυχιακών φοιτητών σε κάθε μάθημα",
      fallCalendar: "Χειμερινό Εξάμηνο",
      springCalendar: "Εαρινό Εξάμηνο",
      programTitle: "Επιστήμη Δεδομένων και Μηχανική Μάθηση",
      moto: "Ενδυναμώνοντας την επόμενη γενιά καινοτομίας με τα δεδομένα ως οδηγό",
      map: "Χάρτης",
      welcomeTo: "Καλώς ορίσατε στο Πρόγραμμα Μεταπτυχιακών Σπουδών",
      ofFemale: "της",
      eceSchool: "Σχολής Ηλεκτρολόγων Μηχανικών και Μηχανικών Υπολογιστών",
      useful_links: "Χρήσιμοι Σύνδεσμοι",
      and: "και",
      attachedFiles: "Συνημμένα Aρχεία",
      pelKicker: "Εθνικό Μετσόβιο Πολυτεχνείο",
      pelHeroTitle: "Προωθώντας το Μέλλον των Ηλεκτρονικών Ισχύος",
      pelHeroSubtitle:
        "Έρευνα και εκπαίδευση σε σύγχρονα συστήματα ηλεκτρονικών ισχύος, ηλεκτρικές κινήσεις και τεχνολογίες μετατροπής ενέργειας.",
      pelHeroCta: "Δείτε την έρευνά μας",
      pelGroupTitle: "Ομάδα Ηλεκτρονικών Ισχύος",
      pelLead:
        "Η Ομάδα Ηλεκτρονικών Ισχύος του Εθνικού Μετσόβιου Πολυτεχνείου συνδυάζει θεωρητική ανάλυση, προηγμένη προσομοίωση και πειραματική επαλήθευση για την ανάπτυξη αποδοτικών, αξιόπιστων και ευφυών λύσεων για τα ενεργειακά συστήματα επόμενης γενιάς.",
      pelResearchCopy:
        "Η τρέχουσα έρευνα καλύπτει μετατροπείς διασύνδεσης με το δίκτυο, αρθρωτούς πολυεπίπεδους μετατροπείς (MMCs), συστήματα HVDC, ηλεκτρικές κινήσεις, μετατροπή ισχύος υψηλής συχνότητας, συστήματα αποθήκευσης ενέργειας με μπαταρίες, τεχνολογίες ημιαγωγών ευρέος ενεργειακού χάσματος και διαχείριση ενέργειας με τεχνικές τεχνητής νοημοσύνης.",
      researchIntro:
        "Δείτε τις ερευνητικές περιοχές, τα έργα και τις δημοσιεύσεις της Ομάδας Ηλεκτρονικών Ισχύος.",
      peopleIntro:
        "Γνωρίστε τα μέλη ΔΕΠ, τους ερευνητές, τους φοιτητές και τους συνεργάτες της ομάδας.",
      peopleProfessor: "Υπεύθυνος Ερευνητικής Ομάδας",
      peopleProfessorRole: "Αναπληρωτής Καθηγητής",
      peopleResearchers: "Ερευνητές",
      peopleResearcherRole: "Ερευνητής",
      peoplePhd: "Υποψήφιοι Διδάκτορες",
      peoplePhdRole: "Υποψήφιος Διδάκτωρ",
      peopleMsc: "Μεταπτυχιακοί & Διπλωματικοί Φοιτητές",
      peopleMscRole: "Μεταπτυχιακός / Διπλωματικός Φοιτητής",
      peopleCurrentActivities: "Τρέχουσες δραστηριότητες",
      peopleError: "Δεν ήταν δυνατή η φόρτωση του προσωπικού.",
      peopleEmpty: "Σύντομα διαθέσιμο.",
      coursesThesesIntro:
        "Δείτε τα μαθήματα που υποστηρίζει η ομάδα και διαθέσιμα θέματα διπλωματικών, μεταπτυχιακών και διδακτορικών εργασιών.",
      coursesError: "Δεν ήταν δυνατή η φόρτωση των μαθημάτων.",
      thesesError: "Δεν ήταν δυνατή η φόρτωση των διπλωματικών εργασιών.",
      currentTheses: "Τρέχουσες διπλωματικές εργασίες",
      completedTheses: "Ολοκληρωμένες διπλωματικές εργασίες",
      coursesThesesEmpty: "Σύντομα διαθέσιμο.",
      contactIntro:
        "Επικοινωνήστε με την Ομάδα Ηλεκτρονικών Ισχύος του Εθνικού Μετσόβιου Πολυτεχνείου.",
      researchCardText:
        "Μετατροπείς, ηλεκτρικές κινήσεις, αποθήκευση ενέργειας και ευφυή ενεργειακά συστήματα.",
      peopleCardText:
        "Γνωρίστε τα μέλη ΔΕΠ, τους ερευνητές, τους φοιτητές και τους συνεργάτες μας.",
      coursesThesesCardText:
        "Εργαστηριακή εκπαίδευση και διαθέσιμα θέματα εργασιών.",
      learnMore: "Περισσότερα",
      footerCopyright:
        "Σχολή Ηλεκτρολόγων Μηχανικών και Μηχανικών Υπολογιστών, Εθνικό Μετσόβιο Πολυτεχνείο",
      labImageAlt: "Εργαστηριακή και ερευνητική δραστηριότητα στο ΕΜΠ",
      peopleImageAlt: "Φοιτητές και ερευνητές σε ακαδημαϊκό περιβάλλον",
      campusImageAlt: "Η πανεπιστημιούπολη του Εθνικού Μετσόβιου Πολυτεχνείου",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en",
    lng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
